export const ORGANIZATIONS_LOADED = 'ORGANIZATIONS_LOADED';
export const ORGANIZATIONS_ERROR = 'ORGANIZATIONS_ERROR';
export const ORGANIZATIONS_FILTER = 'ORGANIZATIONS_FILTER';
export const CATEGORIES_LOADED = 'CATEGORIES_LOADED';
export const CATEGORIES_ERROR = 'CATEGORIES_ERROR';
export const LANGUAGE_LOADED = 'LANGUAGE_LOADED';
export const LANGUAGE_SWITCHED = 'LANGUAGE_SWITCHED';
export const CATEGORIES_UPDATE = 'CATEGORIES_UPDATE';

